module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "advanced-search-form"
  }, [_c('div', {
    staticClass: "builder"
  }, _vm._l((_vm.rows), function(row, index) {
    return _c('div', {
      key: row.id,
      staticClass: "search-row"
    }, [_c('div', {
      staticClass: "is-valid-row pull-right"
    }, [(!_vm.isRowValid(row)) ? _c('i', {
      staticClass: "fa fa-times invalid"
    }) : _vm._e(), _vm._v(" "), (_vm.isRowValid(row)) ? _c('i', {
      staticClass: "fa fa-check valid"
    }) : _vm._e()]), _vm._v(" "), (index === 0) ? _c('div', [_c('span', {
      staticClass: "describe"
    }, [_vm._v("I want to find interactions for")]), _vm._v(" "), _c('time-range-select', {
      attrs: {
        "selectedRange": _vm.range
      },
      on: {
        "onRangeChanged": function($event) {
          return _vm.updateRange($event)
        },
        "onDateRangeSelected": function($event) {
          return _vm.updateDateRangeInput($event)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "describe"
    }, [_vm._v("where")]), _vm._v(" "), _c('search-field-select', {
      attrs: {
        "fields": _vm.searchFields,
        "selectedField": row.field,
        "selectedOperator": row.operator,
        "selectedInput": row.input
      },
      on: {
        "onFieldsChanged": function($event) {
          return _vm.updateRowData(row.id, $event)
        }
      }
    }), _vm._v(" "), (_vm.showPicker) ? _c('span', {
      staticClass: "describe"
    }, [_vm._v("Range")]) : _vm._e(), _vm._v(" "), (_vm.showPicker) ? _c('el-date-picker', {
      staticStyle: {
        "width": "20%"
      },
      attrs: {
        "start-placeholder": "Start",
        "end-placeholder": "End",
        "type": "datetimerange",
        "range-separator": "-"
      },
      model: {
        value: (_vm.dateRange),
        callback: function($$v) {
          _vm.dateRange = $$v
        },
        expression: "dateRange"
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (index >= 1) ? _c('div', [(index === 1) ? _c('el-select', {
      attrs: {
        "placeholder": "Please select"
      },
      model: {
        value: (_vm.searchType),
        callback: function($$v) {
          _vm.searchType = $$v
        },
        expression: "searchType"
      }
    }, _vm._l((_vm.searchTypes), function(currentType) {
      return _c('el-option', {
        key: currentType.id,
        attrs: {
          "label": currentType.value,
          "value": currentType.id
        }
      })
    }), 1) : _vm._e(), _vm._v(" "), (index > 1) ? _c('span', {
      staticClass: "describe"
    }, [_vm._v(_vm._s(_vm.searchType))]) : _vm._e(), _vm._v(" "), _c('search-field-select', {
      attrs: {
        "fields": _vm.searchFields,
        "selectedField": row.field,
        "selectedOperator": row.operator,
        "selectedInput": row.input
      },
      on: {
        "onFieldsChanged": function($event) {
          return _vm.updateRowData(row.id, $event)
        }
      }
    }), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "margin-top": "1px"
      },
      attrs: {
        "type": "default"
      },
      on: {
        "click": function($event) {
          return _vm.removeRow(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])], 1) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        return _vm.addRow()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isAllRowsValid(_vm.rows)
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search\n      ")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aa99403","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/search/AdvancedSearchForm.vue
// module id = 3130
// module chunks = 3